import React from "react";
import { CASES, INDUSTRIES } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export default function Work() {
  return (
    <section id="work" data-testid="work" className="relative py-12 md:py-16 noise">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>Selected work</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
            Outcomes and product portfolio that move the <span className="text-gradient">business</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid md:grid-cols-3 gap-6 md:gap-8">
          {CASES.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                data-testid={`case-${i}`}
                className="group h-full rounded-2xl glass p-6 hover:border-brand/50 transition-all duration-500 hover:-translate-y-1.5"
              >
                <span className="text-xs font-mono uppercase tracking-[0.2em] text-brand">{c.tag}</span>
                <div className="mt-4 flex items-end gap-3">
                  <span className="font-heading text-5xl font-bold text-gradient">{c.metric}</span>
                  <span className="text-sm text-textsub pb-1.5">{c.metricLabel}</span>
                </div>
                <h3 className="mt-6 font-heading text-xl font-semibold leading-snug">{c.title}</h3>
                <p className="mt-3 text-sm text-textsub leading-relaxed">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap items-center gap-3">
            <span className="text-sm text-textsub mr-2">Industries we serve:</span>
            {INDUSTRIES.map((ind) => (
              <span key={ind} className="text-sm rounded-full border border-line px-4 py-1.5 text-textsub hover:text-brand hover:border-brand/50 transition-colors">
                {ind}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
